module.exports = __webpack_public_path__ + "static/media/preloader.89b048c4.png";